import { InputLabel, Select as MuiSelect, styled } from '@mui/material';
import type { FormItemUiDefinition } from 'types/formItem';

export const Wrapper = styled('div')(() => ({ width: '100%' }));

export const StyledSelect = styled(MuiSelect, {
  shouldForwardProp: (prop) =>
    prop !== 'uiDefinitionStyles' && prop !== 'background' && prop !== 'error' && prop !== 'lightError' && prop !== 'formItemUiDefinition',
})<{
  background?: 'transparent' | 'white';
  error?: boolean;
  lightError?: boolean;
  formItemUiDefinition?: FormItemUiDefinition;
}>(({ theme, background = 'transparent', error, lightError, formItemUiDefinition }) => {
  const outlineColor = error || lightError ? theme.palette.error.main : formItemUiDefinition?.columnBorderColor;

  return {
    ...(formItemUiDefinition?.attributeColor && {
      backgroundColor: formItemUiDefinition.attributeColor,
    }),

    minWidth: 0,
    '& .MuiSelect-outlined': {
      backgroundColor: error && !lightError ? theme.palette.error.light : background === 'transparent' ? 'transparent' : theme.palette.common.white,
    },
    // Paint admin colors on the outlined border. A border on the root sits off that outline.
    ...(outlineColor && {
      '&& .MuiOutlinedInput-notchedOutline, &&:hover .MuiOutlinedInput-notchedOutline, &&.Mui-focused .MuiOutlinedInput-notchedOutline, &&.Mui-disabled .MuiOutlinedInput-notchedOutline':
        {
          borderColor: `${outlineColor} !important`,
        },
    }),
    '& svg': {
      width: '20px',
    },

    '& .MuiSelect-select': {
      ...(formItemUiDefinition?.textStyle?.bold && {
        fontWeight: 'bold',
      }),
      ...(formItemUiDefinition?.textStyle?.italic && {
        fontStyle: 'italic',
      }),
      ...(formItemUiDefinition?.textStyle?.underline && {
        textDecoration: 'underline',
      }),
      ...(formItemUiDefinition?.textStyle?.color && {
        color: formItemUiDefinition.textStyle.color,
      }),
    },
    ...(formItemUiDefinition?.textStyle?.color && {
      '& .MuiSelect-select.Mui-disabled': {
        color: formItemUiDefinition.textStyle.color,
        WebkitTextFillColor: formItemUiDefinition.textStyle.color,
      },
    }),
  };
});

export const StyledLabel = styled(InputLabel)({
  whiteSpace: 'wrap',
});
